import React, { useState, useEffect } from 'react';
import { MentionsInput, Mention } from 'react-mentions'
export function DiscussionMentionInput(props) {
    let { value, onChange,onKeyPress, onKeyUp } = props;
    let [users, setUsers] = useState([])
    useEffect(() => {
        let formattedUsers = [];
        let map = new Map();
        props.users.forEach((user) => {
            if (!map.has(user.id)) {
                map.set(user.id, true);
                formattedUsers.push({
                    id: user.id,
                    display: `${user.firstName} ${user.lastName}`
                });
            }
        })
        setUsers(formattedUsers)  
        
    }, [props.users])
    let defaultStyle = {
        control: {
            backgroundColor: '#fff',
            fontSize: 16,
            fontWeight: 'normal',
        },

        '&multiLine': {
            control: {
                minHeight: 100,
            },
            highlighter: {
                padding: 9,
                border: '1px solid transparent',
            },
            input: {
                padding: 9,
                border: '1px solid silver',
            },
        },
        marginBottom: '1em',
        suggestions: {
            list: {
                backgroundColor: 'white',
                border: '1px solid rgba(0,0,0,0.15)',
                fontSize: 14,
            },
            item: {
                padding: '5px 15px',
                borderBottom: '1px solid rgba(0,0,0,0.15)',
                '&focused': {
                    backgroundColor: '#fff4bf',
                },
            },
        },
    }
    return (
        <div>
            <MentionsInput
               className={'mentions-input'}
                value={value}
                onChange={onChange}
                placeholder={props.placeholder}
                style={defaultStyle}
                maxLength={1000}
                onKeyPress={onKeyPress}
                onKeyUp={onKeyUp}
                allowSuggestionsAboveCursor={true}>
                <Mention style={{ backgroundColor: '#fff4bf' }} data={users}
                    markup="@@@____id__^^____display__@@@^^^" appendSpaceOnAdd={true} />
            </MentionsInput>
            <div className='input-characters-remaining'>
                Characters Remaining: {1000 - value.length}
            </div>
        </div>
    );
}